import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class InternalAuditProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'internalAudit'}
            title={'PROCEDURE P13.0 INTERNAL AUDIT'}
            exportTitle={'<h2>Procedure P13.0 Internal Audit</h2>'}
            exportFileName={'internal_audit.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (InternalAuditProcedure);
